export const LOCATION_CHANGE = 'LOCATION_CHANGE/router';

export const locationChange = pathname => ({
  type: LOCATION_CHANGE,
  pathname
})